// extracted by mini-css-extract-plugin
export var success = "success-module--success--KOOrx";
export var title = "success-module--title--3Gh_X";
export var subtitle = "success-module--subtitle--3VoC_";